const SignatureChainStatus = {
  DONE: 'DONE',
  CREATED: 'CREATED',
  FAILED: 'FAILED',
  IN_PROGRESS: 'IN_PROGRESS'
}

export default SignatureChainStatus
